var map = {
	"./components/change-default-pass/change-default-pass.module": [
		"./src/app/components/change-default-pass/change-default-pass.module.ts",
		"components-change-default-pass-change-default-pass-module"
	],
	"./components/profile/profile.module": [
		"./src/app/components/profile/profile.module.ts",
		"components-profile-profile-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;